import React from "react";
import Loader from "../Loader/Loader";
import DocsCards from "./DocsCards";

export interface IImagesProps {
  images?: any[];
  handleRequestImage: (Id: string, name: string, e: any) => any;
  loadingImage: boolean;
}

const GridEpisodeImages: React.FC<IImagesProps> = ({
  images,
  handleRequestImage,
  loadingImage,
}) => {
  if (loadingImage) {
    return <Loader activeLoader label="Descargando Imagen" />;
  }

  return (
    <DocsCards
      items={images ?? []}
      getName={(d) => d.Descripcion ?? d.nombre ?? ""}
      getDate={(d) => d.fecha}
      getIcon={() => "grid"}
      onDownload={(d, e) => handleRequestImage(d.Id, d.Descripcion, e)}
      downloadLabel="Solicitar"
      emptyMessage="No hay imágenes disponibles."
    />
  );
};

export default GridEpisodeImages;
